import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import SmallTitleBase from '../small_title_base'

const Title2 = ({ children, component, colour, isMobile }) => {
  return (
    <SmallTitleBase
      colour={colour}
      component={component}
      componentStyles={styles}
      isMobile={isMobile}
    >
      {children}
    </SmallTitleBase>
  )
}

Title2.propTypes = {
  component: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  isMobile: PropTypes.bool
}

export default Title2
